var exports = {
  "M": "x8b4e8595--d795b0--price-discount",
  "m": "x8b4e8595--d795b0--old-price",
};

module.exports = exports;
